import React, { useState } from "react";
import { Row, Col, Button, Modal, Form, notification } from "antd";
import styles from "../../DashBoard/Payment/Payment.module.scss";
import commonStyles from "../../DashBoard/Subscription/YourPlan/YourPlan.module.scss";
import { paymentEditIcon } from "../../../assets/images";
import { useHistory } from "react-router-dom";
import CustomButton from "../../../common/Buttons/CustomButton";
import { usePaymentDetailsCtx } from "../../../context/PaymentDetailsContext";
import getCreditCardKindIcon from "../../../helpers/getCreditCardKindIcon";
import moment from "moment";
import CreditCardForm from "../../Shared/CreditCardForm/CreditCardForm";
import { useCreditCardActions } from "../../../hooks/useCreditCardActions";
import { TrackAnalytics } from "../../../types/ApplicationTypes";
import buttonStyle from "../ServiceSummary/ServiceSummaryComponent.module.scss"

const ServiceSummaryPayment = () => {
  const [isOpenCreditCardModal, setIsOpenCreditCardModal] = useState<boolean>(
    false
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const history = useHistory();

  const [form] = Form.useForm();

  const {
    isValidCCState,
    saveCreditCard,
    validateAndCheckForm,
    creditCardFormRef,
    shouldDisableButton,
    resetFormAndSetDefaults,
  } = useCreditCardActions(form);

  const {
    defaultSavedCreditCardDetails: creditCard,
    isDefaultSavedCreditCardExists,
    getDefaultSavedCreditCard,
  } = usePaymentDetailsCtx();


  const handleOpenCreditCard = () => setIsOpenCreditCardModal(true);

  const handleSaveCreditCard = async () => {
    try {
      setIsLoading(true);
      await saveCreditCard(true);
      await getDefaultSavedCreditCard();
      resetFormAndSetDefaults();
      setIsOpenCreditCardModal(false);
    } catch (error) {
      // We are already showing an error on the form. so removed toast notification.
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = (modalBtn: string) => {
    if (modalBtn === "AddEditCreditCard") {
      resetFormAndSetDefaults();
      setIsOpenCreditCardModal(false);
    } 
  };

  return (
    <Row className={styles.cardPaymentContainer}>
      <Col span={24}>
        <Row justify="space-between" align="middle" gutter={[0, 15]}>
          {isDefaultSavedCreditCardExists ? (
            <>
              <Col className={styles.creditCardDetails}>
                <Row align="middle" gutter={[10, 0]}>
                  <Col>{getCreditCardKindIcon(creditCard?.kind)}</Col>
                  <Col>
                    <Row className={styles.cardNumber}>
                      **** {creditCard?.last4}
                    </Row>
                    <Row className={styles.serviceSummeryexpiryDate}>
                      Expires {moment(creditCard?.expiresOn).format("MM/YYYY")}
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col className={styles.creditCardActions}>
                <Row justify="end" gutter={[10, 0]}>
                  <Col>
                    <CustomButton
                      type="default"
                      icon={paymentEditIcon}
                      handlerFunction={handleOpenCreditCard}
                      className="iconBtn"
                    />
                  </Col>
                </Row>
              </Col>
            </>
          ) : (
            <>
              <Col id={buttonStyle.checkoutButtonContainer}>
                <Button
                  onClick={handleOpenCreditCard}
                  className={buttonStyle.checkoutButton}
                >
                  Add payment card
                </Button>
              </Col>
            </>
          )}
        </Row>
      </Col>

      <Modal
        className={styles.addEditCreditCardModal}
        visible={isOpenCreditCardModal}
        centered={true}
        width="unset"
        footer={
          <Row
            justify="center"
            gutter={[10, 10]}
            className={`${styles.commonPaymentModalBtns} ${styles.footerMargin}`}
          >
            <Col xs={24} lg={0} />
            <Col>
              <Button
                className={`${styles.modalWhiteBtn} ${styles.cancelBtnWidth}`}
                onClick={() => handleClose("AddEditCreditCard")}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className={`${styles.modalBlueBtn} ${isLoading &&
                  styles.autoWidth} ${shouldDisableButton &&
                  commonStyles.disableBtnOpacity}`}
                onClick={handleSaveCreditCard}
                disabled={shouldDisableButton}
                loading={isLoading}
              >
                Save Credit Card
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center" gutter={[0, 50]}>
          <Col span={24} className={styles.modalTitle}>
            Credit Card Details
          </Col>
          <Col span={24} />
        </Row>

        <CreditCardForm
          form={form}
          ref={creditCardFormRef}
          isModalLayout={true}
          isValidCCState={isValidCCState}
          validateAndCheckForm={validateAndCheckForm}
        />
      </Modal>
    </Row>
  );
};

export default ServiceSummaryPayment;
